import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useQuery } from '../hooks/useQuery';
import { useForm, Controller } from 'react-hook-form';
import { FormControl } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import TextField from '@mui/material/TextField';
import InputMask from 'react-input-mask';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useTheme } from '@mui/material/styles';
import { useSearchParams, useNavigate } from 'react-router-dom';
import CustomizedDialogs from '../components/ModalAlert';
import { useSnackbar } from '../hooks/useSnackbar';
import SaveIcon from '@mui/icons-material/Save';
import { useAuth } from '../hooks/useAuth';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import EditIcon from '@mui/icons-material/Edit';
import {
  cnpjIsFilial,
  cryptedParam,
  decryptData,
  decryptedParam,
} from '../utils';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

export const Step5Cadastro = ({
  activeStep,
  setActiveStep,
  fornecedor,
  setFornecedor,
}) => {
  const theme = useTheme();
  const [dadosBancarios, setDadosBancarios] = React.useState([]);
  const [bancos, setBancos] = React.useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = React.useState(false);
  const [isSavingAccountBank, setIsSavingAccountBank] = React.useState(false);
  const [formaRecebimento, setFormaRecebimento] =
    React.useState('conta_bancaria');
  const [tipoConta, setTipoConta] = React.useState('CONTA_CORRENTE');
  const [documentoContaBancaria, setDocumentoContaBancaria] =
    React.useState('');
  const [codigoBanco, setCodigoBanco] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const [justificativa, setJustificativa] = React.useState('');
  const [show, setShow] = React.useState(false);
  const [showErrorCnpjContaBancaria, setShowErrorCnpjContaBancaria] =
    React.useState(false);
  const navigate = useNavigate();
  const [isRascunho, setIsRascunho] = React.useState(false);
  const [currentDataBanckEdit, setCurrentDataBanckEdit] = React.useState(null);
  const { isUsuarioSebrae, isPrototocoloVencido } = useAuth();
  const snackbar = useSnackbar();
  const [maskConta, setMaskConta] = React.useState('9999999999');
  const [maskAg, setMaskAg] = React.useState('9999');
  const [banco, setBanco] = React.useState(null);
  const [checkStep5, setCheckStep5] = React.useState(false);
  const [disabledFields, setDisabledFields] = React.useState(false);
  const [showModalAlert, setShowModalAlert] = React.useState(false);
  const [showAlertTransfeeraIndisponivel, setShowAlertTransfeeraIndisponivel] =
    React.useState(false);
  const autoCompleteBanco = React.useRef(null);
  const [radioTipoContaMei, setRadioTipoContaMei] = React.useState('');
  const { user } = useAuth();
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      banco: null,
      tipo_conta: 'CONTA_CORRENTE',
    },
  });
  const {
    cadastroStep5,
    showCadastroFornecedor,
    deletarDadosBancarios,
    listarBancos,
    atualizarFormaRecebimento,
  } = useQuery();

  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.codigo + option.banco,
  });

  React.useEffect(() => {
    getBancos();
    if (searchParams.get('fornecedor_id')) {
      const fornecedor_id = decryptData(searchParams.get('fornecedor_id'));
      if (!fornecedor_id) {
        return navigate('/dashboard/listar-cadastros');
      }
      preencherFormulario(fornecedor_id);
    }

    setShowAlertTransfeeraIndisponivel(
      process.env.REACT_APP_TRANSFEERA_VALIDAR === 'false',
    );
  }, []);

  const getBancos = async () => {
    const result = await listarBancos();
    if (result && result.data) {
      setBancos(result.data.data);
    }
  };

  const onChangeCnpjConta = (e) => {
    const doc = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
    const docFornecedorSliced = fornecedor.documento.substring(0, 9);
    if (!docFornecedorSliced.startsWith(doc.substring(0, 9))) {
      e.preventDefault();
      setShowErrorCnpjContaBancaria(true);
      return;
    }

    setShowErrorCnpjContaBancaria(false);
    setDocumentoContaBancaria(e.target.value);
  };

  const preencherFormulario = async (id) => {
    try {
      setLoading(true);
      const result = await showCadastroFornecedor(id);

      if (result && result.data && result.data.data) {
        setFornecedor(result.data.data);
        setValue('forma_recebimento', result.data.data.forma_recebimento);
        setFormaRecebimento(result.data.data.forma_recebimento);
        setDadosBancarios(result.data.data.dados_bancarios);
        setJustificativa(result.data.data.justificativa_forma_recebimento);
      }
      setLoading(false);
    } catch (error) {
      navigate('/dashboard/listar-cadastros');
    }
  };

  const onClickEdit = (dadoBancario) => {
    setCurrentDataBanckEdit(dadoBancario.id);
    setValue('agencia', dadoBancario.agencia);
    setValue('conta', dadoBancario.conta);
    setValue('digito', dadoBancario.digito);
    setValue('digito_agencia', dadoBancario.digito_agencia);
    setValue('tipo_conta', dadoBancario.tipo_conta);

    const bancoSelecionado = bancos.find(
      (b) => b.codigo === dadoBancario.codigo_banco,
    );

    if (bancoSelecionado) {
      setValue('banco', bancoSelecionado);
      setValue('codigo_banco', bancoSelecionado.codigo);
      setBanco(bancoSelecionado);
      setCodigoBanco(bancoSelecionado.codigo);
    }
  };

  const deleteDadosBancarios = async (id) => {
    if (!id) return;
    const result = await deletarDadosBancarios(id);
    if (result && result.data && result.data.data) {
      setFornecedor(result.data.data);
      setDadosBancarios(result.data.data.dados_bancarios);
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleButtonOk = () => {
    setShow(false);
    navigate('/dashboard/listar-cadastros');
  };

  const onSubmit = (data) => {
    data.fornecedor_id = fornecedor.id;
    cadastrarDadosBancarios(data);
  };

  const cadastrarDadosBancarios = async (data) => {
    try {
      data.banco = banco;

      if (fornecedor) {
        setFornecedor({
          ...fornecedor,
        });
      }

      deletarDadosBancarios(currentDataBanckEdit);
      setIsSavingAccountBank(true);

      console.log({
        ...data,
        banco: banco.banco,
        tipo_conta_mei: radioTipoContaMei,
        documento_conta_bancaria: documentoContaBancaria,
      });
      const result = await cadastroStep5({
        ...data,
        banco: banco.banco,
        tipo_conta_mei: radioTipoContaMei,
        documento_conta_bancaria: documentoContaBancaria,
      });
      if (result && result.data && result.data.data) {
        setDadosBancarios(result.data.data);
        const ele = autoCompleteBanco.current.getElementsByClassName(
          'MuiAutocomplete-clearIndicator',
        )[0];
        if (ele) {
          ele.click();
        }
        setValue('banco', null);
        setValue('agencia', '');
        setValue('conta', '');
        setValue('digito', '');
        setValue('tipo_chave_pix', '');
        setValue('chave_pix', '');
        setValue('digito_agencia', '');
        setValue('tipo_conta', '');
        setTimeout(() => {
          clearErrors('banco');
        }, 500);
      }

      if (process.env.REACT_APP_TRANSFEERA_VALIDAR === 'true') {
        setShowModalAlert(true);
      }

      setCurrentDataBanckEdit(null);
    } catch (error) {
      setMessage(error.response.data.message);
      setType('Error');
      setShow(true);
      return;
    } finally {
      setIsSavingAccountBank(false);
    }
  };

  const onCompleteForm = async (rascunho = false) => {
    if (
      formaRecebimento == 'contrato_sem_repasse_financeiro' &&
      !justificativa
    ) {
      snackbar.showSnackbar('Preencha a justificativa');
      return;
    }

    if (
      (dadosBancarios && dadosBancarios.length > 0) ||
      formaRecebimento == 'contrato_sem_repasse_financeiro'
    ) {
      await atualizarFormaRecebimento(fornecedor.id, {
        forma_recebimento: formaRecebimento,
        justificativa,
      });

      if (rascunho) {
        if (isUsuarioSebrae) {
          navigate('/dashboard/listar-cadastros');
        } else {
          if (fornecedor && fornecedor.cnpj == null) {
            navigate(
              `/dashboard/listar-cadastros?fornecedor=${fornecedor.cnpj}`,
              { replace: true },
            );
          } else {
            navigate(
              `/dashboard/listar-cadastros?fornecedor=${fornecedor.cpf}`,
              { replace: true },
            );
          }
        }
        snackbar.showSnackbar('Rascunho salvo com sucesso.');
      } else {
        setActiveStep(activeStep + 1);
      }
    } else {
      setMessage('Cadastre seus dados bancários.');
      setType('Error');
      setShow(true);
      return;
    }
  };

  const onErrors = (err) => {
    console.log(err);
  };

  const onChangeFormaRecebimento = (value) => {
    setFormaRecebimento(value);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit, onErrors)}>
      <CustomizedDialogs
        content={message}
        btnTxt={'Ok'}
        type={type}
        onClick={type == 'Error' ? () => setShow(false) : handleButtonOk}
        handleClose={handleClose}
        visible={show}
      />
      <CustomizedDialogs
        content="Será realizado um pagamento via PIX no valor de R$ 0,01 para validação dos dados bancários da conta informada."
        btnTxt={'Ok'}
        type="success"
        onClick={() => setShowModalAlert(false)}
        visible={showModalAlert}
        handleClose={() => setShowModalAlert(false)}
      />
      <Grid container spacing={2} padding={2}>
        <Grid item xs={12}>
          <p style={{ fontSize: 20, width: '100%', margin: 0 }}>
            <b>Cadastrar</b>
          </p>
        </Grid>

        {formaRecebimento === 'conta_bancaria' && (
          <>
            <Grid item xs={12}>
              <p style={{ fontSize: 16, width: '100%' }}>
                Por favor, informe seus dados bancários
              </p>
            </Grid>
            <Grid item xs={12}>
              <p style={{ fontSize: 16 }}>
                <b>Dados Bancários</b>
              </p>
            </Grid>
          </>
        )}

        <Grid item xs={12} sm={6}>
          <label style={{ color: '#707070' }}>Forma de Recebimento:</label>
          <Controller
            name="forma_recebimento"
            rules={{
              required: 'Campo é obrigatório',
              validate: (value) => {
                return value !== null;
              },
            }}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <Select
                value={formaRecebimento}
                style={{ height: 38 }}
                error={error}
                onChange={(e) => {
                  onChange(e);
                  onChangeFormaRecebimento(e.target.value);
                }}
                fullWidth
              >
                <MenuItem disabled value={null}>
                  Escolha a forma de recebimento
                </MenuItem>
                <MenuItem value={'conta_bancaria'}>Conta Bancária</MenuItem>
                <MenuItem value={'contrato_sem_repasse_financeiro'}>
                  Contrato sem repasse financeiro
                </MenuItem>
              </Select>
            )}
          />
        </Grid>

        {formaRecebimento === 'conta_bancaria' && (
          <Grid item xs={12} sm={6}>
            <label style={{ color: '#707070' }}>Tipo de conta:</label>
            <Controller
              name="tipo_conta"
              rules={{
                required: 'Campo é obrigatório',
                validate: (value) => {
                  return value !== null;
                },
              }}
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Select
                  value={tipoConta}
                  style={{ height: 38 }}
                  error={error}
                  disabled={true}
                  onChange={(e) => {
                    onChange(e);
                    setTipoConta(e.target.value);
                  }}
                  fullWidth
                >
                  <MenuItem disabled value={null}>
                    Escolha o tipo de conta
                  </MenuItem>
                  <MenuItem value={'CONTA_CORRENTE'}>Conta corrente</MenuItem>
                </Select>
              )}
            />
          </Grid>
        )}

        {formaRecebimento === 'conta_bancaria' && (
          <Grid item xs={12} sm={6}>
            <label style={{ color: '#707070' }}>Banco:</label>
            <Controller
              name="banco"
              rules={{
                required: 'Banco é obrigatório',
                validate: (value) => {
                  return value !== null;
                },
              }}
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Autocomplete
                  disablePortal
                  ref={autoCompleteBanco}
                  value={value}
                  isOptionEqualToValue={(option, value) =>
                    option.codigo === value.codigo
                  }
                  options={bancos}
                  filterOptions={filterOptions}
                  getOptionLabel={(option) =>
                    `${option.codigo} - ${option.banco}`
                  }
                  onChange={(e, newValue) => {
                    onChange(e);
                    if (newValue) {
                      setCodigoBanco(newValue.codigo);
                      setBanco(newValue);
                      setValue('banco', newValue);
                      setValue('codigo_banco', newValue.codigo);
                    } else {
                      setCodigoBanco('');
                      setBanco('');
                      setValue('codigo_banco', '');
                    }
                  }}
                  fullWidth
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={error}
                      helperText={error && error.message}
                    />
                  )}
                />
              )}
            />
          </Grid>
        )}

        {fornecedor.declaracao_enquadramento === 'MEI' &&
          formaRecebimento === 'conta_bancaria' && (
            <Grid container item xs={12} sm={6}>
              <RadioGroup
                value={radioTipoContaMei}
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                style={{ width: '100%', marginTop: '1rem' }}
              >
                <Grid container spacing={2} width="100%">
                  <Grid item xs={12} sm={6}>
                    <FormControlLabel
                      value="PF"
                      onChange={(e) => setRadioTipoContaMei(e.target.value)}
                      control={<Radio size="small" />}
                      label={<span>Conta Corrente Pessoa Física</span>}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControlLabel
                      value="PJ"
                      onChange={(e) => setRadioTipoContaMei(e.target.value)}
                      control={<Radio size="small" />}
                      label={<span>Conta Corrente Pessoa Jurídica</span>}
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
            </Grid>
          )}

        {formaRecebimento === 'conta_bancaria' && (
          <>
            <Stack marginTop={2} sx={{ width: '100%' }} spacing={0}>
              <Alert severity="error">
                Caso agência bancária não contenha dígito, favor deixar em
                branco.
              </Alert>
            </Stack>

            {fornecedor !== null && cnpjIsFilial(fornecedor.documento) && (
              <>
                <Grid item xs={12} sm={4} sx={{ mt: 2 }}>
                  <label style={{ color: '#707070' }}>
                    CNPJ da conta bancária (caso seja da matriz)
                  </label>
                  <InputMask
                    style={{ marginTop: '5px' }}
                    mask="**.***.***/****-**"
                    onChange={onChangeCnpjConta}
                    value={documentoContaBancaria}
                  >
                    {(inputProps) => (
                      <TextField
                        style={{ marginTop: '5px' }}
                        margin="normal"
                        fullWidth
                        placeholder="CNPJ da conta"
                      />
                    )}
                  </InputMask>
                  {showErrorCnpjContaBancaria && (
                    <span style={{ color: 'red', fontSize: 12 }}>
                      CNPJ inválido
                    </span>
                  )}
                </Grid>
              </>
            )}

            <Grid container spacing={2} rowSpacing={1}>
              <Grid item xs={12} sm={2}>
                <label style={{ color: '#707070' }}>Agência:</label>
                <Controller
                  rules={{
                    required: 'Agência é obrigatória',
                  }}
                  name="agencia"
                  control={control}
                  render={({
                    field: { onChange, value, onBlur },
                    fieldState: { error },
                  }) => (
                    <InputMask
                      style={{ marginTop: '5px' }}
                      mask={maskAg}
                      maskChar={''}
                      value={value}
                      onBlur={onBlur}
                      onChange={(event) => {
                        onChange(event);
                      }}
                    >
                      {(inputProps) => (
                        <TextField
                          style={{ marginTop: '5px' }}
                          margin="normal"
                          error={error}
                          helperText={error && error.message}
                          fullWidth
                          placeholder="Digite a agência"
                        />
                      )}
                    </InputMask>
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <label style={{ color: '#707070' }}>Dígito da Agência</label>
                <Controller
                  name="digito_agencia"
                  control={control}
                  render={({
                    field: { onChange, value, onBlur },
                    fieldState: { error },
                  }) => (
                    <TextField
                      style={{ marginTop: '5px' }}
                      margin="normal"
                      value={value}
                      onChange={(event) => onChange(event)}
                      fullWidth
                      placeholder="Digite"
                      inputProps={{ maxLength: 1 }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <label style={{ color: '#707070' }}>Conta:</label>
                <Controller
                  rules={{
                    required: 'Conta é obrigatória',
                  }}
                  name="conta"
                  control={control}
                  render={({
                    field: { onChange, value, onBlur },
                    fieldState: { error },
                  }) => (
                    <InputMask
                      style={{ marginTop: '5px' }}
                      mask={maskConta}
                      maskChar={''}
                      value={value}
                      onBlur={onBlur}
                      onChange={(event) => {
                        onChange(event);
                      }}
                    >
                      {(inputProps) => (
                        <TextField
                          style={{ marginTop: '5px' }}
                          margin="normal"
                          error={error}
                          helperText={error && error.message}
                          fullWidth
                          placeholder="Digite a conta"
                        />
                      )}
                    </InputMask>
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <label style={{ color: '#707070' }}>Dígito da conta</label>
                <Controller
                  name="digito"
                  control={control}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      style={{ marginTop: '5px' }}
                      margin="normal"
                      value={value}
                      onChange={onChange}
                      fullWidth
                      placeholder="Digite"
                      inputProps={{ maxLength: 1 }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              display="flex"
              justifyContent={{ xs: 'center', sm: 'flex-end' }}
            >
              <Button
                type="submit"
                variant="contained"
                startIcon={<AddIcon />}
                disabled={
                  isSavingAccountBank ||
                  (dadosBancarios.length > 0 && currentDataBanckEdit === null)
                }
              >
                {isSavingAccountBank ? 'Salvando...' : 'Salvar'}
              </Button>
            </Grid>
            <Grid container item xs={12}>
              <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                  Atenção: O preenchimento incorreto dos dados bancários
                  acarretará no atraso do pagamento!
                </Alert>
              </Stack>
              <div
                style={{
                  width: '100%',
                  border: '1px solid rgb(0, 102, 158)',
                  borderTop: `8px solid ${theme.palette.primary.light}`,
                  borderRadius: 10,
                  padding: 20,
                  justifyContent: 'space-between',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 8,
                }}
              >
                <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                  <span style={{ color: 'rgb(0, 102, 158)', marginRight: 20 }}>
                    <b>Nº</b>
                  </span>
                </div>
                <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                  <span style={{ color: 'rgb(0, 102, 158)', marginRight: 20 }}>
                    <b>Banco</b>
                  </span>
                </div>
                <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                  <span style={{ color: 'rgb(0, 102, 158)', marginRight: 20 }}>
                    <b>Agência</b>
                  </span>
                </div>
                <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                  <span style={{ color: 'rgb(0, 102, 158)', marginRight: 20 }}>
                    <b>Dígito Agência</b>
                  </span>
                </div>
                <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                  <span style={{ color: 'rgb(0, 102, 158)', marginRight: 20 }}>
                    <b>Conta</b>
                  </span>
                </div>
                <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                  <span style={{ color: 'rgb(0, 102, 158)', marginRight: 20 }}>
                    <b>Dígito</b>
                  </span>
                </div>
                {/* <div style={{ flex: '1 1 120px', minWidth: 120 }}>
              <span style={{ color: 'rgb(0, 102, 158)', marginRight: 20 }}><b>Tipo Chave Pix</b></span>
            </div>
            <div style={{ flex: '1 1 120px', minWidth: 120 }}>
              <span style={{ color: 'rgb(0, 102, 158)', marginRight: 20 }}><b>Chave Pix</b></span>
            </div> */}
                <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                  <span style={{ color: 'rgb(0, 102, 158)', marginRight: 20 }}>
                    <b>&nbsp;</b>
                  </span>
                </div>
              </div>
            </Grid>
            {dadosBancarios &&
              dadosBancarios.length > 0 &&
              dadosBancarios.map((res, index) => {
                return (
                  <Grid container item xs={12}>
                    <div
                      style={{
                        width: '100%',
                        border: '1px solid rgb(0, 102, 158)',
                        borderRadius: 10,
                        padding: 20,
                        justifyContent: 'space-between',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 8,
                      }}
                    >
                      <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                        <span
                          style={{ color: 'rgb(0, 102, 158)', marginRight: 20 }}
                        >
                          {index + 1}
                        </span>
                      </div>
                      <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                        <span>{res.banco}</span>
                      </div>
                      <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                        <span>{res.agencia}</span>
                      </div>
                      <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                        <span>{res.digito_agencia}</span>
                      </div>
                      <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                        <span>{res.conta}</span>
                      </div>
                      <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                        <span>{res.digito}</span>
                      </div>
                      {/* <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                  <span>{res.tipo_chave_pix}</span>
                </div>
                <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                  <span>{res.chave_pix}</span>
                </div> */}
                      <div
                        style={{
                          flex: '1 1 120px',
                          minWidth: 120,
                          textAlign: 'right',
                        }}
                      >
                        <EditIcon
                          onClick={() => {
                            onClickEdit(res);
                          }}
                          style={{ cursor: 'pointer' }}
                          color="primary"
                        />
                        <DeleteOutlinedIcon
                          onClick={() => {
                            deleteDadosBancarios(res.id);
                          }}
                          style={{ cursor: 'pointer' }}
                          color="error"
                        />
                      </div>
                    </div>
                  </Grid>
                );
              })}
          </>
        )}

        <Grid container item xs={12}>
          {formaRecebimento === 'contrato_sem_repasse_financeiro' && (
            <textarea
              id="justificativa"
              cols="10"
              rows="10"
              placeholder="Digite sua justificativa para que não seja informada uma conta bancária"
              value={justificativa}
              onChange={({ target }) => setJustificativa(target.value)}
              style={{
                resize: 'none',
                width: '100%',
                borderRadius: '0.2rem',
                border: '1px solid #919191',
                marginBottom: '1rem',
              }}
            />
          )}
        </Grid>
      </Grid>

      {showAlertTransfeeraIndisponivel && (
        <Alert severity="error">
          <p style={{ fontWeight: 'bold', margin: 0 }}>Aviso Importante</p>O
          serviço de validação de dados bancários via Pix está temporariamente
          indisponível. Seu cadastro poderá ser concluído normalmente, mesmo sem
          a validação dos dados bancários neste momento. Assim que o sistema for
          normalizado, a validação poderá ser realizada.
        </Alert>
      )}

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          pt: 2,
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Button
          type="button"
          variant="text"
          color="primary"
          sx={{ mr: { sm: '0.5rem' }, width: { xs: '100%', sm: 'auto' } }}
          onClick={() => {
            if (fornecedor.cnpj) {
              setActiveStep(activeStep - 1);
            } else {
              setActiveStep(activeStep - 2);
            }
          }}
        >
          <ArrowBackIosIcon color="primary" />
          Voltar
        </Button>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            pt: 2,
            justifyContent: 'flex-end',
            width: '100%',
            gap: 1,
          }}
        >
          <Button
            type="button"
            variant="contained"
            color="warning"
            style={{ marginRight: '0.5rem' }}
            onClick={() => {
              setIsRascunho(true);
              onCompleteForm(true);
            }}
          >
            Salvar como rascunho
            <SaveIcon />
          </Button>
          <Button
            type="button"
            variant="contained"
            onClick={() => {
              setIsRascunho(false);
              onCompleteForm();
            }}
          >
            Próximo
          </Button>
        </Box>
      </Box>
    </form>
  );
};
